
import { useCallback } from 'react';
import { Node, Edge } from '@xyflow/react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { NodeData } from '../initial-nodes';

export function useDiagramSave(id: string | undefined) {
  // Save the diagram
  const handleSave = useCallback(async (nodes: Node<NodeData>[], edges: Edge[], silent?: boolean): Promise<{ success: boolean; error?: Error }> => {
    if (!id) return { success: false, error: new Error('No diagram ID') };
    
    try {
      // Garantir que todos os nós têm UUID antes de salvar
      const nodesWithValidation = nodes.map(node => {
        // Adicionando verificação para log
        if (!node.data.uuid) {
          console.error('Node without UUID found during save:', node);
        }
        return node;
      });
      
      // Create a diagram data object with nodes and edges
      const diagramData = {
        nodes: nodesWithValidation,
        edges
      };
      
      // Update the diagram data in the database
      const { error } = await supabase
        .from("diagrams")
        .update({ 
          structure: JSON.stringify(diagramData),
          modified_at: new Date().toISOString()
        })
        .eq("id", id);
      
      if (error) {
        console.error("Error saving diagram:", error);
        if (!silent) {
          toast.error("Erro ao salvar o diagrama");
        }
        return { success: false, error };
      }
      
      if (!silent) {
        toast.success("Diagrama salvo com sucesso");
      }
      return { success: true };
    } catch (error) {
      console.error("Failed to save diagram:", error);
      if (!silent) {
        toast.error("Falha ao salvar o diagrama");
      }
      return { 
        success: false, 
        error: error instanceof Error ? error : new Error('Unknown error')
      };
    }
  }, [id]);

  return { handleSave };
}
